import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import Modal from "../components/modal.react";
import InputCustom from "../components/inputCustom.react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";
import "./galleryItem.css";

export default class GalleryItem extends Component {
  static propTypes = {
    apiHost: PropTypes.string,
    item: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
      wrapperWidth: 0,
      wrapperHeight: 0
    };
  }

  componentDidMount() {
    const { clientWidth, clientHeight } = this.refs.wrapper;
    this.setState({
      wrapperWidth: clientWidth,
      wrapperHeight: clientHeight
    });
  }

  removeGalleryItem = () => {
    const {
      actions,
      item,
      notificationSystem,
      updateDataFromServerAction
    } = this.props;
    actions.removeGalleryItem(item.get("uid")).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        updateDataFromServerAction();
      }
    });
    actions.setIsEditGalleryItemModalVisible(false);
    actions.setIsRemoveGalleryItemModalVisible(false);
  };

  openEditGalleryItemModal = () => {
    const { actions, item } = this.props;
    actions.setIsEditGalleryItemModalVisible(item.get("uid"));
  };

  closeEditGalleryItemModal = () => {
    const { actions } = this.props;
    actions.setIsEditGalleryItemModalVisible(false);
  };

  updateGalleryItem = () => {
    const {
      actions,
      item,
      notificationSystem,
      updateDataFromServerAction
    } = this.props;
    actions
      .updateGalleryItem(item, item.get("uid"))
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          updateDataFromServerAction();
        }
      });
    actions.setIsEditGalleryItemModalVisible(false);
  };

  openRemoveGalleryItemModal = () => {
    const { actions, item } = this.props;
    actions.setIsEditGalleryItemModalVisible(false);
    actions.setIsRemoveGalleryItemModalVisible(item.get("uid"));
  };

  closeRemoveGalleryItemModal = () => {
    const { actions } = this.props;
    actions.setIsRemoveGalleryItemModalVisible(false);
  };

  onLoadImage = () => {
    const { naturalWidth, naturalHeight } = this.refs.image;
    const { wrapperWidth, wrapperHeight } = this.state;

    if (naturalWidth / naturalHeight > wrapperWidth / wrapperHeight) {
      this.setState({
        height: wrapperHeight,
        width: naturalWidth * wrapperHeight / naturalHeight
      });
    } else {
      this.setState({
        height: naturalHeight * wrapperWidth / naturalWidth,
        width: wrapperWidth
      });
    }
  };

  render() {
    const {
      item,
      apiHost,
      isEditModalVisible,
      isRemoveModalVisible,
      actions
    } = this.props;
    if (item) {
      const { width, height, wrapperWidth, wrapperHeight } = this.state;
      const imageStyle = {
        height: height,
        width: width,
        maxWidth: "none",
        maxHeight: "none",
        position: "relative",
        left: -(width - wrapperWidth) / 2,
        top: -(height - wrapperHeight) / 2
      };

      const editGaleryItemProps = {
        actions: actions,
        feature: "galleryItems",
        entity: item,
        uid: item.get("uid")
      };

      return (
        <div>
          <div
            ref="wrapper"
            className="gallery-item-wrapper"
            onClick={this.openEditGalleryItemModal}
          >
            {width === 0 && (
              <div className="gallery-item-preloader row center-xs middle-xs">
                <div className="la-ball-clip-rotate">
                  <div />
                </div>
              </div>
            )}
            <img
              style={imageStyle}
              ref="image"
              src={`${apiHost}/v1/files/${item.getIn([
                "media",
                "fileUID"
              ])}/file`}
              onLoad={this.onLoadImage}
            />
          </div>
          {isEditModalVisible === item.get("uid") && (
            <Modal
              closeModalAction={this.closeEditGalleryItemModal}
              enterAction={this.updateGalleryItem}
              deleteAction={this.openRemoveGalleryItemModal}
              handleKeyDownEvent={true}
            >
              <div className="row">
                <h3 className="col-xs-12">Edytuj element galerii</h3>
                <div className="col-xs-12 center-xs">
                  <img
                    src={`${apiHost}/v1/files/${item.getIn([
                      "media",
                      "fileUID"
                    ])}/file`}
                  />
                </div>
                <div className="col-xs-12">
                  <InputCustom
                    placeholder="Nazwa pliku"
                    field={["name"]}
                    {...editGaleryItemProps}
                  />
                </div>
                <div className="col-xs-12">
                  <InputCustom
                    placeholder="Opis pliku"
                    field={["description"]}
                    {...editGaleryItemProps}
                  />
                </div>
                <div className="col-xs-12">
                  <button className="info" onClick={this.updateGalleryItem}>
                    Aktualizuj
                  </button>
                  <button
                    className="error"
                    onClick={this.openRemoveGalleryItemModal}
                  >
                    Usuń
                  </button>
                </div>
              </div>
            </Modal>
          )}
          {isRemoveModalVisible === item.get("uid") && (
            <Modal
              closeModalAction={this.closeRemoveGalleryItemModal}
              enterAction={this.removeGalleryItem}
              handleKeyDownEvent={true}
            >
              <div className="row">
                <h3 className="col-xs-12">Potwierdź usunięcie</h3>
                <div className="col-xs-12 center-xs">
                  <img
                    src={`${apiHost}/v1/files/${item.getIn([
                      "media",
                      "fileUID"
                    ])}/file`}
                  />
                </div>
                <div className="col-xs-12">
                  <p>Czy napewno usunąć?</p>
                  <button className="error" onClick={this.removeGalleryItem}>
                    Usuń
                  </button>
                </div>
              </div>
            </Modal>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <div
            ref="wrapper"
            className="gallery-item-wrapper"
            onClick={this.openEditGalleryItemModal}
          >
            <div className="gallery-item-preloader row center-xs middle-xs">
              <div className="la-ball-clip-rotate">
                <div />
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/browser/galleries/galleryItem.react.js